import { type BoundingBoxDto, Language } from '@ev-tech/search-modules-api';

// threshold after which clusters are shown as big clusters
export const CLUSTER_SIZE_THRESHOLD = 100;

export const MAX_ZOOM = 22;
export const MIN_ZOOM = 4;

// Buffer around fuzzy circle to avoid real locations not being
// inside the circle in case of fuzzy size calculation inaccuracies.
export const FUZZY_CIRCLE_BUFFER_FACTOR = 1.2;

// Bbox of Hamburg
export const DEFAULT_MAP_BBOX: BoundingBoxDto = {
  southWest: { lat: 52.913_042_899_445_2, lng: 9.481_201_171_875_002 },
  northEast: { lat: 53.956_085_530_987_9, lng: 10.458_984_375_000_002 },
};

export const MAXIMUM_MAP_BBOX: BoundingBoxDto = {
  southWest: { lat: 21.747_538_587_636_043, lng: -19.261_886_964_512_087 },
  northEast: { lat: 67.076_133_583_974_65, lng: 30.867_563_969_025_98 },
};

type LanguageBoundingBoxMap = Partial<Record<Language, BoundingBoxDto>> & { others: BoundingBoxDto };

export const PRIVATE_OFFICE_DEFAULT_MAP_BOUNDING_BOX: LanguageBoundingBoxMap = {
  [Language.en]: {
    northEast: {
      lat: 62.308_793_691_028_05,
      lng: -63.632_812_500_000_01,
    },
    southWest: {
      lat: -5.878_332_109_674_314,
      lng: -126.210_937_500_000_01,
    },
  },
  others: {
    northEast: {
      lat: 65.433_393_322_243_48,
      lng: 26.886_430_176_912_37,
    },
    southWest: {
      lat: 21.544_494_666_155_58,
      lng: -20.538_920_204_916_863,
    },
  },
};
